import React from 'react';
import { Link } from 'react-router-dom';

export function GeneralScoreboardView(props) {
    return (
        <div>
            <div className='w-full h-full flex items-center justify-center'>
                <div className='flex flex-col items-center justify-start w-4/5 bg-gray-800 p-6 rounded-lg shadow-lg'>
                    <h1 className='text-3xl mb-10 text-white'>General Scoreboard</h1>

                    <p className='text-white mb-2'> Your position in the general leaderboard: {props.userPosition ? props.userPosition : 'N/A'}</p>


                    <table className='w-full bg-gray-700 text-gray-100 border border-gray-600 rounded-lg shadow-md'>
                        <thead className='bg-gray-600'>
                            <tr>
                                <th className='px-4 py-2 text-gray-100'>No</th>
                                <th className='px-4 py-2 text-gray-100'>Username</th>
                                <th className='px-4 py-2 text-gray-100'>Points</th>
                                <th className='px-4 py-2 text-gray-100'>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.generalScores.map((generalScore, index) => generalScoreboardRowCB(generalScore, index))}
                        </tbody>
                    </table>
                </div>

            </div>
            <div className="flex flex-wrap justify-center mt-10">
                <Link className="btn-primary mb-4 w-72 md:mx-4 text-center" to="/">
                    Home
                </Link>
                <Link className="btn-secondary mb-4 w-72 md:mx-4" to="/personalScoreboard">
                Personal Scoreboard
                </Link>
            </div>
        </div>
    );



    function generalScoreboardRowCB(generalScore, index) {
        const key = generalScore.id ? `${generalScore.id}-${index}` : index;

        return (
            <tr key={key} className='hover:bg-gray-600 border-b border-gray-500'>
                <td className='px-4 py-2 text-gray-100 text-center'>{index + 1}</td>
                <td className='px-4 py-2 text-gray-100 text-center'>{generalScore.username}</td>
                <td className='px-4 py-2 text-gray-100 text-center'>{generalScore.score} p</td>
                <td className='px-4 py-2 text-gray-100 text-center'>{new Date(generalScore.date).toLocaleDateString()}</td>
            </tr>
        );
    }
}

export default GeneralScoreboardView;
